// Types
import { parseObjectToStrings } from '@helpers/index';
import { CiiSimulatorFormValues } from '@schemas/forms';
import { DefaultParametersValues } from '@schemas/services';

/**
 * This are the values for the optimized speed as string, used for initialization.
 */
export const optimizedSpeedBaseAsString = {
  A: {
    ballastSpeedKts: '-1',
    ladenSpeedKts: '-1',
  },
  B: {
    ballastSpeedKts: '-1',
    ladenSpeedKts: '-1',
  },
  C: {
    ballastSpeedKts: '-1',
    ladenSpeedKts: '-1',
  },
  D: {
    ballastSpeedKts: '-1',
    ladenSpeedKts: '-1',
  },
  E: {
    ballastSpeedKts: '-1',
    ladenSpeedKts: '-1',
  },
};

/**
 * Formats the given data to fit the Formik state structure for CiiSimulator form.
 *
 * @param defaultParameters - Default parameters that define values for the form, such as fuel type, fuel price, etc.
 * @param optimizedSpeeds - Object containing optimized speed values corresponding to different ratings.
 *
 * @returns A formatted object compatible with Formik state for the CiiSimulator form.
 */
export const formatDataToFormikState = (defaultParameters?: DefaultParametersValues): CiiSimulatorFormValues => ({
  fuelType: defaultParameters?.fuelType ?? {
    value: 0,
    label: '-',
    price: 0,
    co2ConversionFactor: 0,
    energyConversion: 0,
  },
  fuelPrice: `${defaultParameters?.fuelPrice ?? '0'}`,
  bulkFuelEnabled: !!defaultParameters?.bulkFuelEnabled,
  bulkFuelPrice: String(defaultParameters?.bulkFuelPrice ?? 0),
  bulkFuelQuantity: String(defaultParameters?.bulkFuelQuantity ?? 0),
  carbonPrice: `${defaultParameters?.carbonPrice ?? '0'}`,
  sailingDays: `${defaultParameters?.sailingDays ?? '0'}`,
  ladenAvgSpeed: `${defaultParameters?.ladenAvgSpeed ?? '0'}`,
  ballastAvgSpeed: `${defaultParameters?.ballastAvgSpeed ?? '0'}`,
  avgBeaufort: `${defaultParameters?.avgBeaufort ?? '0'}`,
  uwc: defaultParameters?.uwc ?? false,
  ciiRating: undefined,
  canOptimize: 1,
  optimizedSpeeds: optimizedSpeedBaseAsString,
  fuelModes: defaultParameters?.fuelModes.map((fuelMode) => parseObjectToStrings(fuelMode)) ?? [],
});
